import { AssetType } from "../types/bikeModel"
import {
  MdDirectionsBike,
  MdElectricBike,
  MdBikeScooter,
  MdElectricCar,
  MdElectricRickshaw,
} from "react-icons/md"

import { FaTrailer, FaShuttleVan, FaChalkboardTeacher } from "react-icons/fa"

export const getAssetIcon = (assetType: AssetType | undefined) => {
  switch (assetType) {
    case "e-bike":
      return MdElectricBike
    case "conference-bike":
      return MdBikeScooter
    case "sign":
      return FaChalkboardTeacher
    case "van":
      return FaShuttleVan
    case "trailer":
      return FaTrailer
    case "ev":
      return MdElectricCar
    case "ev-cart":
      return MdElectricRickshaw
    case "bike":
    default:
      return MdDirectionsBike
  }
}
